import { initializeProjectCollections } from './components/project-collection.js';
import { initializeStatsSliders } from './components/stats-slider.js';
import { initializeTabGroups } from './components/tab-group.js';
import { initializeTestimonialSliders } from './components/testimonial-slider.js';
import { initializeSiteMenus } from './components/site-menu.js';
import { initializeContactInquiry } from './components/contact-inquiry.js';
import { initializeForminatorSuccess } from './components/forminator-success.js';
import { initializeEditorialMediaZoom } from './components/editorial-media-zoom.js';
import { initializeTimelineList } from './components/timeline-list.js';
import { initializeAOS } from './components/animate-on-scroll.js';

initializeProjectCollections();
initializeStatsSliders();
initializeTabGroups();
initializeTestimonialSliders();
initializeSiteMenus();
initializeContactInquiry();
initializeForminatorSuccess();
initializeEditorialMediaZoom();
initializeTimelineList();
initializeAOS({
  duration: 400,
  offset: 150,
});
